// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__9CpWr","title":"Header_title__1mTby","side":"Header_side__15z6A"};